<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop bg-light">
        <div class="col-md-12">
          <div class="bg-white pt-8 pb-8 px-4">
            <div class="relative mx-auto divide-y-2 divide-gray-200">
              <button
                type="button"
                @click="showCreate = true"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
              >
                Create a New Blog

                <svg
                  class="ml-2 bg-indigo-800 rounded-full h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>

              <div class="mt-2 grid gap-8 lg:grid-cols-2 lg:gap-x-5">
                <div
                  class="border rounded-md shadow p-4"
                  v-for="post in posts"
                  :key="post.id"
                >
                  <p class="text-xl font-semibold text-gray-900">
                    <small class="text-sm text-gray-500">
                      <time datetime="2020-03-16">{{
                        formatDate(post.created_at)
                      }}</time> </small
                    ><br />
                    {{ post.title }}<br />
                    <span class="text-base font-normal text-gray-500">
                      {{ post.description }}
                    </span>
                  </p>

                  <div class="mt-3">
                    <button
                      type="button"
                      @click="displayModal(post, 'preview')"
                      class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
                    >
                      Preview
                    </button>
                    <button
                      type="button"
                      @click="displayModal(post, 'edit')"
                      class="ml-1 inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      @click.prevent="deletePost(post)"
                      class="ml-1 inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-red-800 bg-red-100 hover:bg-red-200 focus:outline-none"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="bg-white pt-8 pb-8 px-4">
            <button
              type="button"
              @click="displayCatTagModal('cat')"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
            >
              Create a New Category

              <svg
                class="ml-2 bg-indigo-800 rounded-full h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            <div class="p-2 bg-light mb-4">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="category in categories" :key="category.id">
                      <td>
                        <v-text-field
                          label="name"
                          name="name"
                          v-model="category.name"
                          type="text"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn
                          text
                          small
                          color="#00C853"
                          @click.prevent="updateCategory(category)"
                          >Save</v-btn
                        >
                        <v-btn
                          text
                          small
                          color="#B71C1C"
                          @click.prevent="deleteCategory(category)"
                          >Delete</v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="bg-white pt-8 pb-8 px-4">
            <button
              type="button"
              @click="displayCatTagModal('tag')"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
            >
              Create a New Tag

              <svg
                class="ml-2 bg-indigo-800 rounded-full h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            <div class="p-2 bg-light">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tag in tags" :key="tag.id">
                      <td>
                        <v-text-field
                          label="name"
                          name="name"
                          v-model="tag.name"
                          type="text"
                        ></v-text-field>
                      </td>

                      <td>
                        <v-btn
                          color="#00C853"
                          text
                          small
                          @click.prevent="updateTag(tag)"
                          >Save</v-btn
                        >
                        <v-btn
                          text
                          small
                          color="#B71C1C"
                          @click.prevent="deleteTag(tag)"
                          >Delete</v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <template v-if="showModal">
      <div
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            :class="
              action === 'edit' ? 'sm:max-w-5xl max-w-lg pt-8' : 'sm:max-w-lg'
            "
            class="inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6"
          >
            <div>
              <div v-if="action === 'preview'" class="mt-3 sm:mt-5">
                <div class="flex flex-col shadow-lg overflow-hidden">
                  <div class="flex-shrink-0">
                    <img
                      class="h-48 w-full object-cover bg-white"
                      :src="singleBlog.images.post_image_path"
                      alt=""
                    />
                  </div>

                  <div
                    class="flex-1 bg-white p-3 flex flex-col justify-between"
                  >
                    <div class="flex-1">
                      <a class="cursor-pointer block">
                        <p
                          class="text-2xl font-semibold text-blue-800 uppercase"
                        >
                          <span class="text-base text-gray-300">
                            {{ formatDate(singleBlog.created_at) }} </span
                          ><br />
                          {{ singleBlog.title }}<br />
                          <span class="text-base text-gray-300">
                            {{ singleBlog.category.name }}
                          </span>
                        </p>
                        <p class="mt-3 text-lg text-gray-600">
                          {{ singleBlog.description }}
                        </p>
                      </a>
                    </div>

                    <div class="mt-4">
                      <button
                        @click="redirect(singleBlog)"
                        type="button"
                        class="float-left uppercase inline-flex items-center px-6 py-2 border border-indigo-600 text-sm leading-4 font-medium shadow-sm text-indigo-600 hover:text-gray-50 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Read More
                      </button>

                      <div class="float-right">
                        <a
                          class="cursor-pointer text-gray-400 hover:text-gray-500"
                        >
                          <ShareNetwork
                            network="facebook"
                            :url="
                              'https://www.homesby360.com/news/' +
                                singleBlog.slug
                            "
                            :title="singleBlog.title"
                            :description="singleBlog.description"
                            :quote="singleBlog.title"
                          >
                            <img
                              class="w-7 h-7 rounded-full"
                              src="https://img.icons8.com/fluency/48/000000/facebook.png"
                            />
                          </ShareNetwork>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="mt-5 sm:mt-6 sm:grid sm:grid-cols-1 sm:gap-3 sm:grid-flow-row-dense"
                >
                  <button
                    @click="closeModal()"
                    type="button"
                    class="mt-3 w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                  >
                    Close
                  </button>
                </div>
              </div>

              <div v-else-if="action === 'edit'">
                <v-form>
                  <div class="row">
                    <div v-if="singleBlog.images" class="col-md-12">
                      <template v-if="uploadedImg">
                        <img
                          class="h-52 w-full object-cover"
                          :src="uploadedImg"
                          alt=""
                        />
                        <button
                          type="button"
                          @click="saveUpdateImg(singleBlog.id)"
                          class="m-4 absolute top-0 right-0 px-3 py-1.5 text-sm font-medium rounded-full shadow-sm text-white bg-green-600 hover:bg-greem-700 focus:outline-none"
                        >
                          Save Image
                        </button>
                      </template>
                      <template v-else>
                        <img
                          class="h-52 w-full object-cover"
                          :src="singleBlog.images.post_image_path"
                          alt=""
                        />

                        <div
                          class="flex items-center m-4 absolute top-0 right-0"
                        >
                          <div class="group relative flex items-left">
                            <label
                              for="user_photo"
                              class="rounded-full bg-blue-600 shadow-sm px-2 hover:bg-blue-700 relative text-sm leading-4 text-white"
                            >
                              <span>
                                <i class="fas fa-camera-retro h-4 w-4"></i>
                                Change Image</span
                              >
                            </label>
                            <input
                              accept="image/png, image/jpeg, image/jpg"
                              id="user_photo"
                              name="user_photo"
                              @change="updateFile"
                              type="file"
                              class="absolute w-full h-full opacity-0"
                            />
                          </div>
                        </div>
                      </template>
                    </div>

                    <div class="col">
                      <v-text-field
                        :counter="25"
                        label="title"
                        name="title"
                        v-model="singleBlog.title"
                        type="text"
                      ></v-text-field>
                    </div>

                    <div class="col">
                      <v-text-field
                        required
                        label="description"
                        name="description"
                        v-model="singleBlog.description"
                        type="text"
                      ></v-text-field>
                    </div>
                  </div>

                  <br />
                  <quill-editor
                    ref="myQuillEditor"
                    v-model="singleBlog.content"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
                  />
                </v-form>

                <div
                  class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                >
                  <button
                    @click.prevent="updateBlog(singleBlog)"
                    type="button"
                    class="mt-3 w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:col-start-2 sm:text-sm"
                  >
                    Update
                  </button>
                  <button
                    @click="closeModal()"
                    type="button"
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="showCreate">
      <div
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-5xl sm:align-middle sm:w-full sm:p-6"
          >
            <v-card class="p-2">
              <v-toolbar color="#01579B" class="top-hero6" dark flat>
                <v-toolbar-title>Create Blog</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form v-model="valid">
                  <div class="row">
                    <div class="col">
                      <v-text-field
                        required
                        :counter="50"
                        :rules="nameRules"
                        label="title"
                        name="title"
                        v-model="title"
                        type="text"
                      ></v-text-field>
                    </div>

                    <div class="col">
                      <v-text-field
                        required
                        label="description"
                        name="description"
                        v-model="description"
                        :rules="descRules"
                        type="text"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <v-text-field
                        :rules="slugRules"
                        required
                        label="slug"
                        name="slug"
                        v-model="slug"
                        type="text"
                      ></v-text-field>
                    </div>

                    <div class="col">
                      {{ categorySelected }}
                      <label for="exampleFormControlSelect1">Categories</label>
                      <select
                        class="form-control"
                        v-model="categorySelected"
                        id="exampleFormControlSelect1"
                      >
                        <option
                          :value="category.id"
                          v-for="category in categories"
                          :key="category.id"
                          >{{ category.name }}</option
                        >
                      </select>
                    </div>

                    <div class="col">
                      <label for="exampleFormControlSelect1">Tags</label>
                      <select
                        class="form-control"
                        v-model="tagSelected"
                        id="exampleFormControlSelect1"
                      >
                        <option
                          :value="tag.id"
                          v-for="tag in tags"
                          :key="tag.id"
                          >{{ tag.name }}</option
                        >
                      </select>
                    </div>

                    <div class="col">
                      <label for="group-image">Image</label>
                      <input
                        type="file"
                        @change="uploadFiles"
                        name="image"
                        class="form-control"
                        accept="image/png, image/jpeg"
                      />
                    </div>
                  </div>
                  <br />
                  <quill-editor
                    ref="myQuillEditor"
                    v-model="content"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
                  />

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <div
                      class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                    >
                      <button
                        :disabled="!valid || content == '' || disableButton"
                        @click.prevent="createPost"
                        type="button"
                        class="disabled:opacity-75 mt-3 w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:col-start-2 sm:text-sm"
                      >
                        Create
                      </button>
                      <button
                        @click="showCreate = false"
                        type="button"
                        class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      >
                        Cancel
                      </button>
                    </div>
                  </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </template>

    <!-- MODAL -->
    <template v-if="tagCategory">
      <div
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="sm:max-w-lg inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6"
          >
            <v-card v-if="type === 'cat'">
              <v-toolbar color="#01579B" dark flat>
                <v-toolbar-title>Create Category</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  label="Name"
                  name="name"
                  v-model="category.name"
                  type="text"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  :disabled="category.name.length < 3"
                  color="#01579B"
                  class="text-white"
                  @click.prevent="createCategory"
                  >Create</v-btn
                >
              </v-card-actions>
            </v-card>

            <v-card v-if="type === 'tag'">
              <v-toolbar color="#01579B" dark flat>
                <v-toolbar-title>Create Tags</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  label="Name"
                  name="name"
                  v-model="tag.name"
                  type="text"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  :disabled="tag.name.length < 3"
                  color="#01579B"
                  class="text-white"
                  @click.prevent="createTag"
                  >Create</v-btn
                >
              </v-card-actions>
            </v-card>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import moment from "moment";
import Swal from "sweetalert2";
export default {
  props: {
    source: String
  },

  data() {
    return {
      tagCategory: false,
      disableButton: false,
      posts: [],
      valid: true,
      images: [],
      updatedImage: [],
      uploadedImg: "",
      showCreate: false,
      showModal: false,
      singleBlog: "",
      action: "",

      categorySelected: "",
      tagSelected: "",

      nameRules: [
        v => !!v || "Title is required",
        v => (v && v.length <= 50) || "Name must be less than 50 characters"
      ],

      descRules: [v => !!v || "Description is required"],

      slugRules: [v => !!v || "Slug is required"],

      categories: [],
      tags: [],

      title: "",
      slug: "",
      content: "",
      description: "",

      category: {
        name: ""
      },

      tag: {
        name: ""
      },

      editorOption: {
        theme: "snow"
      }
    };
  },

  created() {
    this.getCategories();
    this.getTags();
    this.getPosts();
  },

  methods: {
    saveUpdateImg(blogId) {
      var config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      let formData = new FormData();

      $.each(this.updatedImage, function(key, image) {
        formData.append(`image[${key}]`, image);
      });

      formData.append("blogId", blogId);

      window.axios.post("api/updateBlogImage", formData, config).then(
        () => this.getPosts(),
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Image successfully updated",
          showConfirmButton: false,
          timer: 1500
        }),
        (this.showModal = false)
      );
    },

    displayCatTagModal(type) {
      this.tagCategory = true;
      this.type = type;
    },

    closeCatTagModal() {
      this.tagCategory = false;
      this.type = "";
    },

    displayModal(blog, action) {
      this.showModal = true;
      this.singleBlog = blog;
      this.action = action;
    },

    closeModal() {
      this.showModal = false;
      this.singleBlog = "";
      this.action = "";
      this.updatedImage = [];
      this.uploadedImg = "";
    },

    formatDate(date) {
      let newDate = moment.utc(date).format("LL");
      return (this.dataModal = newDate);
    },

    uploadFiles(e) {
      this.images = e.target.files || e.dataTransfer.files;
      console.log(this.images);
    },

    updateFile(e) {
      const file = e.target.files[0];
      this.uploadedImg = URL.createObjectURL(file);

      this.updatedImage = e.target.files || e.dataTransfer.files;
    },

    getCategories() {
      window.axios.get("/api/categories").then(res => {
        this.categories = res.data;
      });
    },

    getTags() {
      window.axios.get("/api/tags").then(res => {
        this.tags = res.data;
      });
    },

    createPost() {
      this.disableButton = true;
      var config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function(progressEvent) {
          this.percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.$forceUpdate();
        }.bind(this)
      };

      let filesImages = new FormData();

      $.each(this.images, function(key, image) {
        filesImages.append(`images[${key}]`, image);
      });

      filesImages.append("title", this.title);
      filesImages.append("slug", this.slug);
      filesImages.append("content", this.content);
      filesImages.append("description", this.description);
      filesImages.append("category", this.categorySelected);
      filesImages.append("tag", this.tagSelected);

      window.axios
        .post("/api/posts", filesImages, config)
        // {selected: this.selected}
        .then(() => {
          this.showCreate = false;
          this.disableButton = false;
          this.getPosts();
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Blog successfully created",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    getPosts() {
      window.axios.get("/api/posts").then(res => {
        this.posts = res.data;
      });
    },

    updateBlog(blog) {
      window.axios.put("/api/posts/" + blog.id, blog).then(() => {
        this.getPosts();
        this.closeModal();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Blog successfully updated",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    deletePost(post) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton:
            "ml-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-green-800 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500",
          cancelButton:
            "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-red-800 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500r"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire(
          {
            title: "You are DELETING this blog",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, DELETE the blog",
            cancelButtonText: "cancel",
            reverseButtons: true
          },
          (this.isHidden = false)
        )
        .then(result => {
          if (result.value) {
            window.axios.delete("/api/posts/" + post.id).then(() => {
              this.getPosts();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Blog successfully deleted",
                showConfirmButton: false,
                timer: 1500
              });
            });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancel",
              "Ok the blog is not deleted",
              "error"
            );
          }
        });
    },

    redirect(post) {
      this.$router.push({ name: "Post", params: { id: post.slug } });
    },

    createCategory() {
      window.axios.post("/api/categories", this.category).then(() => {
        this.category = {};
        this.getCategories();
        this.closeCatTagModal();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Category successfully created",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    createTag() {
      window.axios.post("/api/tags", this.tag).then(() => {
        this.tag = {};
        this.getTags();
        this.closeCatTagModal();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Tag successfully created",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    updateTag(tag) {
      window.axios
        .patch("/api/tags/" + tag.id, {
          tagName: tag.name
        })
        .then(() => {
          this.getTags();
        });
    },

    updateCategory(category) {
      window.axios
        .patch("/api/categories/" + category.id, {
          categoryName: category.name
        })
        .then(() => {
          this.getCategories();
        });
    },

    deleteTag(tag) {
      window.axios.delete("/api/tags/" + tag.id).then(() => {
        this.getTags();
      });
    },

    deleteCategory(category) {
      window.axios.delete("/api/categories/" + category.id).then(() => {
        this.getCategories();
      });
    },

    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    }
  },

  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  }
};
</script>
<style>
.ql-editor {
  min-height: 20rem;
}
</style>
